import { Component, Directive, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

@Directive()
export abstract class Base implements OnDestroy {
  destroy$: Subject<any> = new Subject();

  /**
   * Handles the destroy event.
   */
  protected destroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Executes all the destroys actions.
   */
  ngOnDestroy() {
    this.destroy();
  }
}
